<template>
  <div class="grid-view app-main-page-tab">
    <div class="main-content">
      <div style="width: 100%;margin-top: 5px; min-width: 1280px" class="cargo-advance-search bpm-approval-process">
        <div class="section">
          <el-form
            label-position="left"
            label-width="85px"
          >
            <el-row style="margin-bottom: 5px;" :gutter="10">
              <el-col :span="24">
                <el-button type="primary" @click="toQuery">
                  {{ $t('CargoMsg.Cargo_Query') }}
                </el-button>
                <el-button type="primary" @click="toCreateProcess">
                  {{ $t('CargoMsg.Cargo_CreateProcess') }}
                </el-button>
                <el-button type="primary" @click="toEditProcess">
                  {{ $t('CargoMsg.Cargo_EditProcess') }}
                </el-button>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item :label="$t('Tool.platformId')" label-width="70px">
                  <cargo-advance-select
                    no="tenantId"
                    :select-type="selectTypeNames.TENANT"
                    :url="URL.sys.tenant"
                    :cache="false"
                    filterable
                    :show-custom-label-in-option="true"
                    :custom-label="companyLabel"
                    callback-method-type="value"
                    @parentCallBack="filterTenantIdChangeHandler"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('CargoMsg.Cargo_ApplicationBranch1')" label-width="85px">
                  <cargo-advance-select
                    filterable
                    no="officeIds"
                    :select-type="selectTypeNames.basic_data_Office"
                    :cache="false"
                    :multiple="true"
                    :default-multiple-value="filter.officeIds"
                    :static-options="filterOffices"
                    clearable
                    @parentCallBack="item => filter.officeIds = item.value"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('CargoMsg.Cargo_FormName')" label-width="70px">
                  <cargo-advance-select
                    tag-value="code"
                    :static-options="workflowTypes"
                    @parentCallBack="p=>{filter.documentConfigId=p.value}"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  :label="$t('CargoMsg.Cargo_WhetherItIsEnabled')"
                  prop="initiateBranchCompany"
                  class="auto-width"
                  label-width="70px"
                >
                  <cargo-advance-select
                    :static-options="yesOrNotList"
                    clearable
                    tag-value="code"
                    :default-value="filter.enabled"
                    @parentCallBack="p=>{filter.enabled=p.value}"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="260309"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          @rowDataChanged="rowDataChanged"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          v-show="filter.total>0"
          config-module="260309"
          :total="filter.total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="toQuery"
        />
      </div>
    </div>
    <el-dialog
      slot="reference"
      v-el-drag-dialog
      :close-on-click-modal="false"
      class="dialog"
      :visible.sync="showPlatformSettingDialog"
      :title="platformSettingTitle"
      inline-message
      width="390px"
    >
      <el-form
        ref="platformSetting"
        :model="documentPlatformConfigForm"
        label-width="110px"
        label-position="right"
      >
        <el-form-item :label="$t('Tool.platformId')" required>
          <cargo-advance-select
            no="tenantId"
            :select-type="selectTypeNames.TENANT"
            :url="URL.sys.tenant"
            :cache="false"
            filterable
            :show-custom-label-in-option="true"
            :custom-label="companyLabel"
            callback-method-type="value"
            :default-value="String(documentPlatformConfigForm.tenantId||'')"
            style="width: 235px;"
            @parentCallBack="tenantIdChangeHandler"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_ApplicationBranch1')" required>
          <cargo-advance-select
            no="officeIds"
            :select-type="selectTypeNames.basic_data_Office"
            :cache="false"
            filterable
            :multiple="true"
            :default-multiple-value="documentPlatformConfigForm.officeIds"
            :static-options="offices"
            placeholder=""
            style="width: 235px;"
            @parentCallBack="officeIdChangeHandler"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_FormName')" required>
          <cargo-advance-select
            no="75"
            :select-type="selectTypeNames.basic_data_WorkflowTypes"
            :cache="false"
            filterable
            :default-value="documentPlatformConfigForm.documentConfigId"
            :static-options="workflowTypes"
            tag-value="code"
            placeholder=""
            style="width: 235px;"
            @parentCallBack="item => (documentPlatformConfigForm.documentConfigId = item.value)"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_NumberOfConfigurableBranches')" required>
          <el-select v-model="documentPlatformConfigForm.branchCount" clearable style="width: 235px;">
            <el-option
              v-for="item in branchCountDropList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_AdministratorSettings')" required>
          <cargo-advance-select
            no="userIds"
            :select-type="selectTypeNames.basic_data_User"
            :cache="false"
            filterable
            :multiple="true"
            :default-multiple-value="documentPlatformConfigForm.userIds"
            :static-options="userList"
            style="width: 235px;"
            :placeholder="$t('CargoMsg.Cargo_PleaseSelectUser')"
            @parentCallBack="item=>documentPlatformConfigForm.userIds = item.value"
          />
        </el-form-item>
        <el-form-item class="label-none custom" :label="$t('CargoMsg.Cargo_Remarks')">
          <el-input v-model="documentPlatformConfigForm.remark" type="textarea" :rows="5" style="width: 235px;" />
        </el-form-item>
        <!--        <el-form-item :label="$t('sysManage.baseConfig.Cargo_ApplicationBranch2.warehouse')">-->
        <!--          <cargo-advance-select-->
        <!--            filterable-->
        <!--            :select-type="selectTypeNames.basic_data_Company"-->
        <!--            :callback-params="{key:'warehouseId'}"-->
        <!--            callback-method-type="value"-->
        <!--            :default-value="routeWareHouseForm.warehouseId"-->
        <!--            style="width: 170px;"-->
        <!--            @parentCallBack="getValueFromChild"-->
        <!--          />-->
        <!--        </el-form-item>-->
        <!--        <el-form-item :label="$t('sysManage.baseConfig.routeWareHouseConfiguration.remark')">-->
        <!--          <el-input v-model="routeWareHouseForm.remark" type="textarea" rows="2" />-->
        <!--        </el-form-item>-->
      </el-form>
      <div slot="footer">
        <span>{{ $t('CargoMsg.Cargo_DocumentPlatformConfigNote') }}</span>
        <el-button type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button @click="cancel">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { getOfficeListByTenantId } from '@/api/office'
import { getUserByTenantIdAndOfficeIds } from '@/api/user'
import * as WorkflowConstants from '@/class/cargo/model/parameters/WorkflowConstants'
import { documentPlatformConfigActive, documentPlatformConfigList, documentPlatformConfigSave } from '@/api/workflow'
import * as RadioStatusConstants from '@/class/cargo/model/parameters/RadioStatusConstants'
import { deepCopy, DocumentManage } from '@/utils/commonUtil'
import { getAllTenant } from '@/api/auth'

export default {
  name: 'BpmApprovalProcessAdvanceSetting',
  components: {
    cargoAdvanceSelect
  },
  data() {
    return {
      documentPlatformConfigForm: {
        id: null,
        tenantId: 0,
        officeIds: [],
        documentConfigId: 0,
        branchCount: null,
        userIds: [],
        remark: ''
      },
      filter: {
        tenantId: null,
        officeIds: [],
        documentConfigId: null,
        runningState: null,
        enabled: null,
        total: 0,
        pageNum: 0,
        pageSize: 20
      },
      platformSettingTitle: '',
      showPlatformSettingDialog: false,
      tenants: [],
      offices: [],
      filterOffices: [],
      // allOffice: [],
      userList: [],
      workflowTypes: Array.from(WorkflowConstants.WORKFLOW_TYPES),
      branchCountDropList: [],
      URL,
      yesOrNotList: RadioStatusConstants.YES_NO_TYPES,
      documentManage: new DocumentManage(),
      selectedData: null,

      selectTypeNames: TYPE_NAMES,
      fullscreenLoading: null,
      searchConditions: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      rowData: [],
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        // onRowDoubleClicked: this.onRowDoubleClicked,
        onRowClicked: this.onRowClicked,
        onRowSelected: this.onRowSelected,
        onSortChanged: this.rowDataChanged
      },

      showRouteWareHouseMaintainTitle: '',
      isEdit: false,
      columnDefs: [
        // {
        //   headerName: '', width: 55, checkboxSelection: true,
        //   sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        //   headerCheckboxSelection: true
        // },
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'serialNumber',
          width: 25,
          sortable: false
        }, {
          headerName: this.$t('Tool.platformId'),
          field: 'tenantId',
          valueFormatter: (params) => {
            return this.tenantLabel(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ApplicationBranch1'),
          field: 'officeName'
          // valueFormatter: (params) => {
          //   return ColumnUtils.officesLabelFuncWithAll(params.data.tenantId, params.value, this.allOffice)
          // },
          // filterParams: {},
          // filterValueGetter: (params) => {
          //   return ColumnUtils.officesLabelFuncWithAll(params.data.tenantId, params.data.officeIds, this.allOffice)
          // }
        }, {
          headerName: this.$t('CargoMsg.Cargo_FormName'),
          field: 'documentConfigId',
          valueFormatter: (params) => {
            return ColumnUtils.workflowTypeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_NumberOfConfigurableBranches'),
          field: 'branchCount'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: 'runningState',
          cellRenderer: params => {
            const changeEnabled = this.documentManage.getPath('toChangeEnabled')
            const id = params.data.id
            const name = params.value === 9 ? this.$t('CargoMsg.Cargo_Deactivate') : this.$t('CargoMsg.Cargo_Enable')
            const state = -params.value
            if (params.value === 9) {
              return `<button><div onclick="${changeEnabled}(${id}, ${state})" style="display: inline-block;color:rgba(217, 3, 29);margin-right: 5px;cursor: pointer">${name}</div></button>`
            }
            return `<button><div onclick="${changeEnabled}(${id}, ${state})" style="display: inline-block;color:rgba(146, 199, 63);margin-right: 5px;cursor: pointer">${name}</div></button>`
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          field: 'remark',
          valueFormatter: (params) => {
            return params.value
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_UpdatePerson'),
          field: 'modifierId',
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.UpdateTime'),
          field: 'lastModified',
          valueFormatter: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Creator'),
          field: 'creatorId',
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.DateOfCreation2'),
          field: 'createTime',
          valueFormatter: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }
      ]
    }
  },
  watch: {
    'documentPlatformConfigForm.tenantId': {
      immediate: true,
      handler: function() {
        // this.documentPlatformConfigForm.officeIds = []
        // this.documentPlatformConfigForm.userIds = []
        // this.userList = []
        const tenantId = this.documentPlatformConfigForm.tenantId
        if (!tenantId) {
          this.offices = []
          return
        }
        const list = LocalStorageUtils.getConfiguration(tenantId)
        if (list) {
          this.offices = [{ officeId: 0, chineseName: '全部', englishName: 'ALL' }, ...list]
          return
        }
        getOfficeListByTenantId({ tenantId }).then(resp => {
          this.offices = [{ officeId: 0, chineseName: '全部', englishName: 'ALL' }, ...resp.data]
          LocalStorageUtils.setConfiguration(tenantId, resp.data)
        })
      },
      deep: true
    },
    'filter.tenantId': {
      immediate: true,
      handler: function() {
        let tenantId = this.filter.tenantId
        if (!tenantId) {
          this.filterOffices = []
          return
        }
        const list = LocalStorageUtils.getConfiguration('filter_' + tenantId)
        if (list) {
          this.filterOffices = list
          return
        }
        tenantId = Number(tenantId)
        // this.filterOffices = this.allOffice.filter(item => item.tenantId === tenantId)
        getOfficeListByTenantId({ tenantId }).then(resp => {
          this.filterOffices = resp.data
          LocalStorageUtils.setConfiguration('filter_' + tenantId, this.filterOffices)
        })
      },
      deep: true
    },
    'documentPlatformConfigForm.officeIds': {
      immediate: true,
      handler: function() {
        if (!this.documentPlatformConfigForm.officeIds || this.documentPlatformConfigForm.officeIds.length === 0) {
          this.userList = []
          return
        }
        if (this.documentPlatformConfigForm.officeIds.indexOf(0) !== -1) {
          getUserByTenantIdAndOfficeIds({ tenantId: this.documentPlatformConfigForm.tenantId, officeIds: null }).then(res => {
            this.userList = res.data
          })
          return
        }
        getUserByTenantIdAndOfficeIds({ tenantId: this.documentPlatformConfigForm.tenantId, officeIds: this.documentPlatformConfigForm.officeIds.join(',') }).then(res => {
          this.userList = res.data
        })
      },
      deep: true
    }
  },
  async beforeMount() {
    const context = this
    this.documentManage.set('toChangeEnabled', function(id, state) {
      context.toChangeEnabled(id, state)
    })
  },
  mounted() {
  },
  async created() {
    // await allOffice().then(resp => {
    //   this.allOffice = resp.data
    // })
    await getAllTenant().then(res => {
      this.tenants = res.data
    })
    for (let i = 1; i <= 20; i++) {
      this.branchCountDropList = [...this.branchCountDropList, { label: i, value: i }]
    }
    this.toQuery()
  },
  methods: {
    toCreateProcess() {
      this.platformSettingTitle = this.$t('common.btn.new')
      this.showPlatformSettingDialog = true
    },
    toEditProcess() {
      if (!this.selectedData || !this.selectedData.id) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.documentPlatformConfigForm = deepCopy(this.selectedData)
      this.platformSettingTitle = this.$t('common.btn.edit')
      this.showPlatformSettingDialog = true
    },
    companyLabel(data) {
      if (data) {
        return '[' + data.id + ']' + data.name
      }
      return ''
    },
    tenantIdChangeHandler(value) {
      this.documentPlatformConfigForm.tenantId = value
      this.documentPlatformConfigForm.officeIds = []
      this.documentPlatformConfigForm.userIds = []
      this.userList = []
    },
    filterTenantIdChangeHandler(value) {
      this.filter.tenantId = value
      this.filter.officeIds = []
    },
    officeIdChangeHandler(item) {
      if (item.value.indexOf(0) !== -1) {
        this.documentPlatformConfigForm.officeIds = [0]
      } else {
        this.documentPlatformConfigForm.officeIds = item.value
      }
      this.documentPlatformConfigForm.userIds = []
    },
    save() {
      if (!this.validateForm()) return
      this.loading = getLoading()
      documentPlatformConfigSave(this.documentPlatformConfigForm).then(() => {
        this.selectedData = null
        this.documentPlatformConfigForm = {
          id: null,
          tenantId: null,
          officeIds: [],
          documentConfigId: null,
          branchCount: null,
          userIds: [],
          remark: ''
        }
        this.showPlatformSettingDialog = false
        this.$message.success(this.$t('common.tips.saveSuccess'))
        this.toQuery()
      }).catch(async err => {
        if (err === this.$t('CargoMsg.Cargo_WorkflowsPlatformConfigRepeat')) {
          // this.$message.error(this.$t('CargoMsg.Cargo_ExistDocumentPlatformConfig'))
          this.$confirm(err, this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('Message.GotIt'),
            showCancelButton: false,
            type: 'warning'
          })
        }
        // } else {
        //   this.$message.error(err)
        // }
      }).finally(() => {
        this.loading.close()
      })
    },
    tenantLabel(tenantId) {
      for (const tenant of this.tenants) {
        if (tenantId.toString() === tenant.id) {
          return this.$store.getters.language === 'zh' ? tenant.name : tenant.englishName
        }
      }
      return ''
    },
    // 启用禁用
    toChangeEnabled(id, state) {
      this.loading = getLoading()
      documentPlatformConfigActive({ id: id, runningState: state }).then(() => {
        const array = this.rowData.filter(item => item.id === id)
        array[0].runningState = state
        this.gridOptions.api.refreshCells({ force: true })
        this.$message.success(this.$t('CargoMsg.Cargo_EditedSuccessfully'))
        this.toQuery()
      }).catch(err => {
        if (err === this.$t('CargoMsg.Cargo_WorkflowsPlatformConfigRepeat')) {
          // if (err.code === '700100') {
          // this.$message.error(this.$t('CargoMsg.Cargo_ExistDocumentPlatformConfig'))
          this.$confirm(err, this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('Message.GotIt'),
            showCancelButton: false,
            type: 'warning'
          })
        }
        // } else {
        //   this.$message.error(err)
        // }
      }).finally(() => {
        this.loading.close()
      })
    },
    toQuery() {
      const params = this.filter
      if (typeof params.enabled === 'boolean') {
        params.runningState = params.enabled ? 9 : -9
      } else {
        delete params.runningState
      }
      this.loading = getLoading()
      documentPlatformConfigList(params).then(res => {
        this.rowData = res.data.list
        ColumnUtils.addSerialNumber(this.rowData)
        params.total = res.data.total
      }).finally(() => {
        this.loading.close()
      })
    },
    cancel() {
      this.documentPlatformConfigForm = {
        id: null,
        tenantId: null,
        officeIds: [],
        documentConfigId: null,
        branchCount: null,
        userIds: [],
        remark: ''
      }
      this.showPlatformSettingDialog = false
    },
    // 行首多选框勾选事件
    onRowSelected(event) {
      if (!event || !event.data) return
      if (event.node.isSelected()) {
        this.selectedData = null
        this.onRowClicked(event)
      }
    },
    // 行点击触发事件
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedData = null
      const node = event.data
      if (node.id) this.selectedData = node
    },
    onRowDoubleClicked(event) {
      if (!event || !event.data) return
      this.selectedData = event.data
      this.documentPlatformConfigForm = this.selectedData
      this.platformSettingTitle = this.$t('common.btn.edit')
      this.showPlatformSettingDialog = true
    },
    validateForm() {
      if (!this.documentPlatformConfigForm.tenantId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectTenantId'))
        return false
      }
      if (!this.documentPlatformConfigForm.officeIds || this.documentPlatformConfigForm.officeIds.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectOfficeIds'))
        return false
      }
      if (!this.documentPlatformConfigForm.documentConfigId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectDocumentConfigId'))
        return false
      }
      if (!this.documentPlatformConfigForm.branchCount) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBranchCount'))
        return false
      }
      if (!this.documentPlatformConfigForm.userIds || this.documentPlatformConfigForm.userIds.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectUserIds'))
        return false
      }
      return true
    },
    rowDataChanged(params) {
      ColumnUtils.sortChanged(params, this.columnDefs, this.rowData)
    }
  }
}
</script>
